import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getFilteredLanguages } from '../../../../../redux/actions/languages'
import { getNovelties } from '../../../../../redux/actions/novelties'
import { getRoles } from '../../../../../redux/actions/roles'
import { storeSeminar, toggleFormSeminar, updateSeminar } from '../../../../../redux/actions/seminars'
import { getSeminartypes } from '../../../../../redux/actions/seminartypes'
import { formValidator, resetFormValidator } from '../../../../../redux/actions/validator'
import { IRootState } from '../../../../../redux/types'
import { ISeminar } from '../../models/Seminars'
import { useTranslation } from 'react-i18next'

export const useSeminarModal = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation(['global'])

  const { userBrands } = useSelector((state: IRootState) => state.brand)
  const { seminarSelected } = useSelector((state: IRootState) => state.seminar)
  const { seminartypes } = useSelector((state: IRootState) => state.seminartype)
  const { novelties } = useSelector((state: IRootState) => state.novelty)
  const { globalFamilyId, globalBrandId, globalLanguageId, globalCountriesId } = useSelector((state: IRootState) => state.global)
  const { isValidForm } = useSelector((state: IRootState) => state.validator)

  const VISIBILITY = [
    { id: 0, name: t('private') },
    { id: 1, name: 'VIP' },
    { id: 2, name: t('public') },
    { id: 3, name: t('preregistration') }
  ]

  const STATUS = [
    { id: 1, name: t('active') },
    { id: 0, name: t('inactive') }
  ]

  const [seminarState, setSeminarState] = useState<ISeminar>({
    id: null,
    brand: null,
    line: null,
    novelty: null,
    title: '',
    description: '',
    language: null,
    countries: [],
    visibility: VISIBILITY[0],
    highlight: 0,
    role: null,
    cover: '',
    seminartype: null,
    status: STATUS[0],
    datetime: null
  })

  useEffect(() => {
    dispatch(getRoles())
    dispatch(getFilteredLanguages())
    if (seminartypes.length === 0) {
      dispatch(getSeminartypes())
    }
  }, [seminartypes])

  useEffect(() => {
    if (novelties.length === 0) {
      dispatch(
        getNovelties({
          family_id: globalFamilyId,
          brand_id: globalBrandId,
          language_id: globalLanguageId,
          countries: globalCountriesId,
          requesttype: 0,
          type: 'novelties'
        })
      )
    }
  }, [novelties, globalFamilyId, globalBrandId, globalCountriesId, globalLanguageId])

  useEffect(() => {
    if (seminarSelected != null) {
      const coverUrl = seminarSelected.cover || ''
      const coverName = coverUrl.substring(coverUrl.lastIndexOf('/') + 1)

      setSeminarState({
        id: seminarSelected.id,
        brand: seminarSelected.brand ? userBrands.find((brand: any) => brand.id === seminarSelected.brand.id) : null,
        line: seminarSelected.line,
        countries: seminarSelected.countriesIds,
        language: seminarSelected.language,
        role: seminarSelected.role,
        novelty: seminarSelected.novelty,
        seminartype: seminarSelected.seminartype,
        title: seminarSelected.title,
        description: seminarSelected.description,
        cover: coverName || null,
        highlight: seminarSelected.highlight,
        datetime: seminarSelected.datetime != null ? dayjs(seminarSelected.datetime) : null,
        status: STATUS.find((statusItem: any) => statusItem.id === seminarSelected.status),
        visibility: VISIBILITY.find((visibilityItem: any) => visibilityItem.id === seminarSelected.visibility)
      })
    }
  }, [seminarSelected, userBrands])

  useEffect(() => {
    if (isValidForm) {
      dispatch(resetFormValidator())
      if (seminarState.id !== null) {
        dispatch(updateSeminar(seminarState))
      } else {
        dispatch(storeSeminar(seminarState))
      }
    }
  }, [isValidForm, seminarState])

  const handleInputChange = (inputName: string, value: any) => {
    console.log('handle')
    console.log(inputName, value)
    setSeminarState({ ...seminarState, [inputName]: value })
  }

  const handleSubmit = () => {
    console.log('seminarState')
    console.log(seminarState)
    dispatch(
      formValidator({
        title: [seminarState.title, 'required', 'general'],
        description: [seminarState.description, 'required', 'general'],
        type: [seminarState.seminartype, 'required', 'general'],
        countries: [seminarState.countries, 'notempty', 'general'],
        language: [seminarState.language, 'required', 'general'],
        status: [seminarState.status, 'required', 'general'],
        visibility: [seminarState.visibility, 'required', 'general'],
        role: [seminarState.role, 'required', 'general'],
        cover: [seminarState.cover, 'required', 'addOn']
      })
    )
  }

  const handleCloseModal = () => {
    dispatch(toggleFormSeminar())
  }

  return {
    seminarState,
    VISIBILITY,
    STATUS,
    handleInputChange,
    handleSubmit,
    handleCloseModal
  }
}
